// Zachowanie nagłówka loterii:
//  1) po scrollu dokleja pigułkę do górnej krawędzi (klasa .is-scrolled),
//  2) mobilny burger otwiera/zamyka rozwijany panel (.is-open).

const header = document.getElementById('site-header');

if (header) {
	const burger = header.querySelector('.site-header__burger');
	const SCROLL_THRESHOLD = 20;

	// --- 1) przyklejanie po scrollu ---
	const onScroll = () => {
		header.classList.toggle('is-scrolled', window.scrollY > SCROLL_THRESHOLD);
	};
	onScroll();
	window.addEventListener('scroll', onScroll, { passive: true });

	// --- 2) menu mobilne ---
	const setOpen = (open) => {
		header.classList.toggle('is-open', open);
		if (burger) {
			burger.setAttribute('aria-expanded', open ? 'true' : 'false');
			burger.setAttribute('aria-label', open ? 'Zamknij menu' : 'Otwórz menu');
		}
	};

	burger?.addEventListener('click', () => {
		setOpen(!header.classList.contains('is-open'));
	});

	// zamknij po kliknięciu w link menu (płynne przejście do kotwicy)
	header.querySelectorAll('.site-header__menu a, .site-header__panel-cta').forEach((link) => {
		link.addEventListener('click', () => setOpen(false));
	});

	// zamknij po powrocie do widoku desktop
	const mq = window.matchMedia('(min-width: 992px)');
	mq.addEventListener('change', (e) => { if (e.matches) setOpen(false); });

	// zamknij klawiszem Escape
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') setOpen(false);
	});
}
